import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  PgProviderFeesFindResponse,
  PgProviderFeesUpdateRequest,
  PgProviderFeesUpdateResponse,
  pgProviderFeeApi,
} from '../../../lib/api/pgProviderFee';
import { pgProviderFeeQuery } from '../queries';

export const useUpdatePgProviderFeesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<PgProviderFeesUpdateResponse, Error, PgProviderFeesUpdateRequest>({
    mutationFn: (body) => pgProviderFeeApi.updateFees(body),
    onSuccess: async (response) => {
      // 🔴 진행 중인 조회를 먼저 끊는다. 새로고침과 저장이 겹치면 저장 전 값을 읽은 GET 이
      // 나중에 도착해 저장 결과를 덮어쓰고, 화면이 옛 값으로 돌아간다. 그 상태에서 다른 칸을
      // 고치면 바뀐 행 계산이 옛 값 기준이 되어 방금 저장한 요율까지 되돌려 보낸다.
      await queryClient.cancelQueries({ queryKey: pgProviderFeeQuery.list().queryKey });
      queryClient.setQueryData<PgProviderFeesFindResponse>(pgProviderFeeQuery.list().queryKey, { fees: response.fees });
      // 이력은 큐를 거쳐 쌓이므로 즉시 조회하면 비어 있을 수 있다. 무효화만 해두고 사용자가 탭을 열 때 다시 읽는다.
      void queryClient.invalidateQueries({ queryKey: pgProviderFeeQuery.histories._def });
    },
  });
};
